<template>
  <div>
    <h4>Contacts</h4>
    <p>Add, remove and edit associated employees.</p>
    <button
      class="btn-default btn-create"
      type="button"
      style="margin: 0px;"
      @click="createContact"
    >
      Create new contact
    </button>
    <div v-for="(contact, index) in contactList">
      <h5 style="display:inline-block;">Contact {{ index + 1 }}</h5>
      <textInput
        title="Full name"
        :keyChain="['contacts', index, 'name']"
        placeholder="Forename Surname"
      ></textInput>
      <textInput
        title="Job role"
        :keyChain="['contacts', index, 'title']"
        placeholder="Title at your organization"
      ></textInput>
      <textInput
        title="Email"
        :keyChain="['contacts', index, 'email']"
        placeholder="email@example.com"
        type="email"
      ></textInput>
      <textInput
        title="Phone number"
        :keyChain="['contacts', index, 'phone_number']"
        placeholder="(555) 555-5555"
        type="tel"
      ></textInput>
      <textInput
        title="LinkedIn"
        :keyChain="['contacts', index, 'linkedin']"
        placeholder="https://www.linkedin.com/in/larskroijer/"
        type="url"
      ></textInput>
      <div>
        <button
          class="btn-default btn-delete"
          type="button"
          style="float: right;"
          @click="removeContact(index)"
        >
          Remove contact
        </button>
      </div>
      <br />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import textInput from "./textInput.vue";

export default {
  name: "provider-page",
  components: {
    textInput: textInput
  },
  computed: {
    ...mapGetters({
      getProperty: "getEditedProviderValueByKeyChain"
    }),
    contactList: function() {
      return this.getProperty(["contacts"]);
    }
  },
  methods: {
    ...mapMutations({
      deleteProviderProperty: "deleteEditedProviderPropertyByKeyChain"
    }),
    createContact: function() {
      this.$store.commit("createNewProviderProperty", "contacts");
    },
    removeContact: function(index) {
      this.deleteProviderProperty(["contacts", index]);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/elements/contacts.vue